export default __webpack_public_path__ + "static/pinata_scaled-14e0089cc25f85929fb8aaded3bbad7d.gif";